import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root') as HTMLElement;

const root = ReactDOM.createRoot(rootElement);

const contentBaseUrl = rootElement.getAttribute('contentBaseUrl');

let builderParam = rootElement.getAttribute('builder');
let modelParam = rootElement.getAttribute('model');
const sp = new URLSearchParams(window.location.search);
const builder = sp.get("b");
if (builder) {
    builderParam = builder;
}
const model = sp.get("m");
if (model) {
    modelParam = model;
}

const contentUrl = contentBaseUrl + `/builders/${builderParam}/VRTours/${modelParam}`;

root.render(
  <React.StrictMode>
    <App contentUrl={contentUrl} />
  </React.StrictMode>
);
